import { get, isNil } from 'lodash';
import moment from 'moment';
import React from 'react';
import { doesCountryUse12HoursFormat } from '../constants/location';
import { TELEMETRY_ACCURACY_DEFAULT_VALUE, TELEMETRY_MULTIPLICATOR_DEFAULT_VALUE } from '../constants/telemetry';

export const formatTS = (ts) => {
  const momentInst = moment.unix(ts).utc();
  const is12HoursFormat = doesCountryUse12HoursFormat();

  return `${momentInst.format('MMMM D, YYYY')} ${momentInst.format(is12HoursFormat ? 'LTS' : 'HH:mm:ss')}`;
};

export const formatFloat = (fixed) => (float) => Number.parseFloat(float).toFixed(fixed);

const METRIC_VALUE_CONFIG = {
  id: {
    label: 'Session ID',
  },
  type: {
    label: 'Session Type',
  },
  duration: {
    label: 'Duration',
  },
  userIdTag: {
    label: 'User ID Tag',
  },
  sessionEnergy: {
    label: 'Session Energy',
    format: formatFloat(3),
    units: 'kWh',
  },
  presentSoc: {
    label: 'Present Soc',
    format: formatFloat(2),
  },
  presentVoltage: {
    label: 'Present Voltage',
    format: formatFloat(2),
    units: 'V',
  },
  presentLoading: {
    label: 'Present Loading',
    format: formatFloat(2),
    units: 'A',
  },
  presentPower: {
    label: 'Present Power',
    format: formatFloat(3),
    units: 'kW',
  },
  start_time: {
    label: 'Start Time',
    format: formatTS,
  },
  end_time: {
    label: 'End Time',
    format: formatTS,
  },
  departure_time: {
    label: 'Departure Time',
    format: formatTS,
  },
  energy_limit: {
    label: 'Energy Limit',
    format: formatFloat(2),
    units: 'kW',
  },
  energy_requested: {
    label: 'Requested Charging Power',
    format: formatFloat(2),
    units: 'kW',
  },
  chargingLoadLimit: {
    label: 'Charging Load Limit',
    format: formatFloat(2),
    units: 'A',
  },
  current_limit: {
    label: 'Charging Load Limit',
    format: formatFloat(2),
    units: 'A',
  },
  dischargingLoadLimit: {
    label: 'Discharging Load Limit',
    format: formatFloat(2),
    units: 'A',
  },
  current_discharging_limit: {
    label: 'Discharging Load Limit',
    format: formatFloat(2),
    units: 'A',
  },
  power_discharging_requested: {
    label: 'Requested Discharging Power',
    format: formatFloat(2),
    units: 'kW',
  },
  requestedChargingLoad: {
    label: 'Requested Charging Load',
    format: formatFloat(2),
    units: 'A',
  },
  current_requested: {
    label: 'Requested Charging Load',
    format: formatFloat(2),
    units: 'A',
  },
  requestedDischargingLoad: {
    label: 'Requested Discharging Load',
    format: formatFloat(2),
    units: 'A',
  },
  current_discharging_requested: {
    label: 'Requested Discharging Load',
    format: formatFloat(2),
    units: 'A',
  },
  number_of_phases: {
    label: 'No. of Phases during this Session',
  },
  session_type: {
    label: 'Session Type',
  },
  session_id: {
    label: 'Session ID',
  },
  session_info: {
    label: 'Session Info',
  },
  fault_info: {
    label: 'Fault Info',
  },
  power_autorization: {
    label: 'Power Authorization',
  },
  code: {
    label: 'Code',
  },
  description: {
    label: 'Description',
  },
  source: {
    label: 'Source',
  },
};

export const makeMetricValueString = (key, value, config = {}) => {
  const { labelPrefix = ':', dynamicDictionary = {} } = config;
  const metricsConfig = { ...METRIC_VALUE_CONFIG, ...dynamicDictionary };
  const props = get(metricsConfig, key, null);

  if (props) {
    const {
      format = (val) => val, label, units = '', multiplicator,
    } = props;
    const displayValue = !isNil(value) ? format(multiplicator ? value * multiplicator : value) : 'N/A';
    const displayUnits = !isNil(value) ? units : '';

    if (key === 'duration') {
      const time = moment.utc(value * 1000).format('HH:mm:ss');

      return (
        <>
          {label}
          {labelPrefix}
          {' '}
          <span className="unit">{time}</span>
        </>
      );
    }

    return (
      <>
        {label}
        {labelPrefix}
        {' '}
        <span className="unit">
          {displayValue}
          {' '}
          {displayUnits}
        </span>
      </>
    );
  }
  const displayValue = !isNil(value) ? value : 'N/A';

  return (
    <>
      {key}
      {labelPrefix}
      {' '}
      <span className="unit">{displayValue}</span>
    </>
  );
};

export const makeMetricConfigs = (dictionary) => dictionary.reduce((acc, metric) => {
  acc[metric.code] = {
    label: metric.title || metric.code,
    units: metric.units,
    format: formatFloat(metric.accuracy || TELEMETRY_ACCURACY_DEFAULT_VALUE),
    multiplicator: metric.multiplicator || TELEMETRY_MULTIPLICATOR_DEFAULT_VALUE,
  };

  return acc;
}, {});
